import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../../shared/store/view/types';
import { ModuleId } from '../../../../shared/store/navigation/types';
import { WorkLocationDetailsComponent } from './work-location-details/work-location-details.component';
import { WorkLocationEditComponent } from './work-location-edit/work-location-edit.component';
import { WorkLocationCreateComponent } from './work-location-create/work-location-create.component';

const routes: Routes = [
  {
    path: 'Configuration/WorkLocations',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkLocation,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: WorkLocationDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkLocation,
          breadcrumb: { label: ' ', alias: 'workLocationDetails' },
        },
      },
      {
        path: 'Edit/:id',
        component: WorkLocationEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkLocation,
          breadcrumb: { label: ' ', alias: 'workLocationEdit' },
        },
      },
      {
        path: 'Create',
        component: WorkLocationCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkLocation,
          breadcrumb: { label: ' ', alias: 'workLocationCreate' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkLocationRoutingModule {}
